import React from 'react';
import './endereco.scss';

//Componentes
import Breadcrumbs from '../../components/breadcrumbs';
import NavigationButtons from '../../components/navigationButtons';
import Field from '../../components/field';
import Typeahead from '../../components/typeahead';
import Form from '../../components/form';
import CheckObligation from '../../components/checkObligation';
import FieldTelefone from '../../components/fieldTelefone';


class Endereco extends React.Component {

  componentWillMount() {
    this.formFields = []
    let { getListEnderecoPaisAction, getListEnderecoEstadoAction, endereco } = this.props;

    getListEnderecoEstadoAction(endereco.endereco_pais);
    //getListEnderecoPaisAction();
    this.props.configuracaoDdi();
  }

  render() {
    let { changeEnderecoValueForm, handleChangeTypeahead, setIdDDIPaisEndereco } = this.props;
    let {
      formEndereco,
      endereco_pais,
      typeaHeadEnderecoPaisList,
      endereco_estado,
      typeaHeadEnderecoEstadoList,
      loadingEnderecoCEP,
      loadingEnderecoPais,
      loadingEnderecoEstado,
      endereco_idDDDpais,
    } = this.props.endereco;

    const {ddiFixoBrasil, listPais} = this.props.ddiReducer;

    return (
      <section className="container">
        <div className="col" >
          <Breadcrumbs />
        </div>
        <Form name="enderecoForm" noValidate={true}>

          <CheckObligation field="endereco_pais">
            {(validacoes) =>
              <div className="col-50">
                {/* <Field
                  type="text"
                  //loading={loadingEnderecoPais}
                  required={validacoes.obrigatorio}
                  label="País"
                  name="endereco_pais"
                  value="BRASIL"
                  readOnly={true}
                  returnObject={this.createRefFields}
                /> */}
                <Typeahead
                  dataSource={listPais}
                  fieldValue="IdPais"
                  fieldText="Nome"
                  readonly={true}
                  onChange={handleChangeTypeahead}
                  value={endereco_pais}
                  required={validacoes.obrigatorio}
                  loading={loadingEnderecoPais}
                  name="endereco_pais"
                  label="País"
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>

          <CheckObligation field="endereco_cep">
            {(validacoes) =>
              <div className="col-50">
                <Field
                  type="number"
                  mask={endereco_pais === "BRA" ? "99999-999" : "99999999"}
                  placeholder="Digite seu CEP"
                  loading={loadingEnderecoCEP}
                  required={validacoes.obrigatorio}
                  label="CEP"
                  name="endereco_cep"
                  value={formEndereco.endereco_cep}
                  onChange={changeEnderecoValueForm}
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>

          <CheckObligation field="endereco_provincia" fieldConditional={{ 'endereco_pais': endereco_pais }}>
            {(validacoes) =>
              <div className="col">
                <Field
                  type="text"
                  placeholder="Digite a Província"
                  required={validacoes.obrigatorio}
                  label="Província"
                  name="endereco_provincia"
                  minlength={3}
                  maxlength={100}
                  value={formEndereco.endereco_provincia}
                  onChange={changeEnderecoValueForm}
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>

          <CheckObligation field="endereco_estado" fieldConditional={{ 'endereco_pais': endereco_pais }}>
            {(validacoes) =>
              <div className="col-50">
                <Typeahead
                  dataSource={typeaHeadEnderecoEstadoList}
                  fieldValue={'IdEstado'}
                  fieldText={"Nome"}
                  onChange={handleChangeTypeahead}
                  value={endereco_estado}
                  required={validacoes.obrigatorio}
                  loading={loadingEnderecoEstado}
                  name="endereco_estado"
                  label="Estado"
                  //disabled={typeaHeadEnderecoEstadoDisabled} 
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>

          <CheckObligation field="endereco_cidade" fieldConditional={{ 'endereco_pais': endereco_pais }}>
            {(validacoes) =>
              <div className="col-50">
                <Field
                  type="text"
                  placeholder="Digite a Cidade"
                  required={validacoes.obrigatorio}
                  label="Cidade"
                  name="endereco_cidade"
                  minlength={3}
                  maxlength={100}
                  value={formEndereco.endereco_cidade}
                  onChange={changeEnderecoValueForm}
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>

          <CheckObligation field="endereco_logradouro">
            {(validacoes) =>
              <div className="col">
                <Field
                  type="text"
                  placeholder="Digite o Logradouro"
                  required={validacoes.obrigatorio}
                  label="Logradouro"
                  name="endereco_logradouro"
                  minlength={3}
                  maxlength={80}
                  value={formEndereco.endereco_logradouro}
                  onChange={changeEnderecoValueForm}
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>


          <CheckObligation field="endereco_numero">
            {(validacoes) =>
              <div className="col-50">
                <Field
                  type="text"
                  placeholder="Digite o Número"
                  required={validacoes.obrigatorio}
                  label="Número"
                  name="endereco_numero"
                  minlength={1}
                  maxlength={50}
                  value={formEndereco.endereco_numero}
                  onChange={changeEnderecoValueForm}
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>

          <CheckObligation field="endereco_complemento">
            {(validacoes) =>
              <div className="col-50">
                <Field
                  type="text"
                  placeholder="Digite o Complemento"
                  required={validacoes.obrigatorio}
                  label="Complemento"
                  name="endereco_complemento"
                  maxlength={100}
                  value={formEndereco.endereco_complemento}
                  onChange={changeEnderecoValueForm}
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>


          <CheckObligation field="endereco_bairro">
            {(validacoes) =>
              <div className="col-50">
                <Field
                  type="text"
                  placeholder="Digite o Bairro"
                  required={validacoes.obrigatorio}
                  label="Bairro"
                  name="endereco_bairro"
                  minlength={1}
                  maxlength={50}
                  value={formEndereco.endereco_bairro}
                  onChange={changeEnderecoValueForm}
                  returnObject={this.createRefFields}
                />
              </div>}
          </CheckObligation>

          <div className="col-50">
            <CheckObligation field="endereco_ddiTelefoneFixo">
              {(validacoes) => (
                <div className="col-20 p-0">
                  <FieldTelefone
                    type="ddi"
                    placeholder="+999"
                    required={formEndereco.endereco_telefoneFixo.length > 0 ? true : validacoes.obrigatorio}
                    label="DDI"
                    name="endereco_ddiTelefoneFixo"
                    value={ddiFixoBrasil ? "+55" : formEndereco.endereco_ddiTelefoneFixo}
                    maxlength={5}
                    onChange={changeEnderecoValueForm}
                    returnObject={this.createRefFields}
                    idDDIpais={endereco_idDDDpais}
                    onChangeDDI={setIdDDIPaisEndereco}
                    readOnly={ddiFixoBrasil}
                    selectToogle={!ddiFixoBrasil}
                    listPais={listPais.filter(x => x.DDI !== null)}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="endereco_telefoneFixo">
              {(validacoes) =>
                <div className="col-70 p-0">

                  <FieldTelefone
                    type="tel"
                    required={validacoes.obrigatorio}
                    label="Telefone Fixo (DDD + Número)"
                    name="endereco_telefoneFixo"
                    value={formEndereco.endereco_telefoneFixo}
                    onChange={changeEnderecoValueForm}
                    returnObject={this.createRefFields}
                    //mask="+999 (99)99999-9999"
                    maxlength={20 - formEndereco.endereco_ddiTelefoneFixo.replace("+", "").length}
                    ddiForMask={formEndereco.endereco_ddiTelefoneFixo}
                  />

                </div>}
            </CheckObligation>
          </div>         

        </Form>
        <div className="col">
          <NavigationButtons history={this.props.history} validateFields={this.validateFields} />
        </div>
      </section>
    );
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  validateFields = async () => {
    let list = []

    return new Promise(resolve => {
      for (let key in this.formFields) {
        if (this.formFields[key].input === null) {
          delete this.formFields[key] //retirar campo não visível da validação (cidade, estado ou provincia)    
        } else {
          if (key === 'endereco_provincia') {
            this.props.handleChangeTypeahead({value: null, name: 'endereco_estado'});//atribuir valor nulo para estado e cidade caso a provincia esteja habilitada
            this.props.changeEnderecoValueForm('endereco_cidade', null);
          } else if (key === 'endereco_cidade') {
            this.props.changeEnderecoValueForm('endereco_provincia', null);//atribuir valor nulo para provincia caso a cidade esteja habilitada
          }
          this.formFields[key].validate(this.formFields[key].input)
          .then(r => {
            list.push({ name: this.formFields[key].props.name, valid: r })
            if (Object.keys(this.formFields).length === list.length)
              resolve(list)
          })
        }     
      }
    })
  }
}

export default Endereco;
